// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__C9KHM","right":"styles_right__1-nmg"};